const initialState = { 
  loading: false,
  success: null,
  error: null
}

function resetPasswordAgentReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_PASSWORD_AGENT_SGH_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'RESET_PASSWORD_AGENT_SGH_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'RESET_PASSWORD_AGENT_SGH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default resetPasswordAgentReducer